module.exports = __webpack_public_path__ + "static/media/ATS-V2-CeQuiVousAttend.ccec5100.jpg";